import React, { Component } from 'react';
import ReactTable from 'react-table';
import { matchSorter } from 'match-sorter';
import 'react-table/react-table.css';

// 통화 표시 포맷: 값이 없으면 '-', KRW는 정수, 그 외는 소수 2자리
function formatMoney(value, fractionDigits) {
  if (value == null || value === '' || isNaN(value)) {
    return '-';
  }
  return Number(value).toLocaleString(undefined, {
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  });
}

const priceCell = (fractionDigits) => (row) =>
  (
    <div style={{ textAlign: 'right' }}>
      {formatMoney(row.value, fractionDigits)}
    </div>
  );

export default class RetailPriceTable extends Component {
  render() {
    return (
      <ReactTable
        data={this.props.data}
        filterable
        defaultPageSize={20}
        className="-striped -highlight"
        defaultSorted={[{ id: 'ProductCode', desc: false }]}
        columns={[
          {
            Header: 'Product Code',
            accessor: 'ProductCode',
            filterAll: true,
            filterMethod: (filter, rows) =>
              matchSorter(rows, filter.value, { keys: ['ProductCode'] }),
          },
          {
            Header: 'Model',
            accessor: 'Model',
            filterAll: true,
            filterMethod: (filter, rows) =>
              matchSorter(rows, filter.value, { keys: ['Model'] }),
          },
          {
            Header: 'US (USD)',
            accessor: 'USDRetail',
            filterable: false,
            Cell: priceCell(2),
          },
          {
            Header: 'KR (KRW)',
            accessor: 'KRWRetail',
            filterable: false,
            Cell: priceCell(0),
          },
          {
            Header: 'AA Cost (USD)',
            accessor: 'AACost',
            filterable: false,
            Cell: priceCell(2),
          },
        ]}
      />
    );
  }
}
